import React, { useEffect, useState } from 'react';
import PersonIcon from '@material-ui/icons/Person';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  Card,
  CardTitle,
  CardDescription,
  PrimaryButton,
  FormGrid,
  StyledTextField,
  CheckboxWrapper,
} from '../styledComponents';
import { getDifusionChannels } from '../api';
import { TYPES, useGlobalActions } from '../../../context/globalActions';

const MONTHS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 83 }, (_, i) => currentYear - 18 - i);

export default function StepDatos({ onNext, isLoading }) {
  const [form, setForm] = useState({
    nombre: '',
    celular: '',
    comoTeEnteraste: '',
    dia: '',
    mes: '',
    anio: '',
    experienciaVales: false,
  });
  const [difusionChannels, setDifusionChannels] = useState([]);
  const { handleOpenSnackbar } = useGlobalActions();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheckbox = e => {
    setForm({ ...form, experienciaVales: e.target.checked });
  };

  const handleGetDifusionChannels = async () => {
    try {
      const data = await getDifusionChannels();
      setDifusionChannels(data);
    } catch {
      handleOpenSnackbar('Algo salió mal, intente de nuevo', TYPES.ERROR);
    }
  };

  const isValid =
    form.nombre.trim() &&
    form.celular.trim() &&
    form.comoTeEnteraste &&
    form.dia &&
    form.mes &&
    form.anio;

  useEffect(() => {
    handleGetDifusionChannels();
  }, []);

  const handleNext = () => {
    const fechaNacimiento = `${form.anio}-${String(form.mes).padStart(
      2,
      '0',
    )}-${String(form.dia).padStart(2, '0')}`;
    const { dia, mes, anio, ...rest } = form;
    onNext({ ...rest, fechaNacimiento });
  };

  return (
    <Card>
      <PersonIcon style={{ fontSize: 36, color: '#00843d' }} />
      <CardTitle>Tus datos</CardTitle>
      <CardDescription>
        Ingresa tu información para continuar con el registro.
      </CardDescription>
      <FormGrid>
        <StyledTextField
          id="nombre"
          name="nombre"
          label="Nombre completo"
          value={form.nombre}
          onChange={handleChange}
          variant="filled"
        />
        <StyledTextField
          id="celular"
          name="celular"
          label="Número celular"
          type="tel"
          value={form.celular}
          onChange={handleChange}
          variant="filled"
          inputProps={{ maxLength: 10 }}
        />
        <StyledTextField
          id="comoTeEnteraste"
          name="comoTeEnteraste"
          label="¿Cómo te enteraste de nosotros?"
          select
          value={form.comoTeEnteraste}
          onChange={handleChange}
          variant="filled"
          disabled={difusionChannels.length === 0}
        >
          {difusionChannels.map(opt => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </StyledTextField>
        <div style={{ gridColumn: '1 / -1' }}>
          <p
            style={{
              fontSize: 12,
              color: 'rgba(0,0,0,0.6)',
              margin: '0 0 6px',
            }}
          >
            Fecha de nacimiento
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <StyledTextField
              select
              name="dia"
              label="Día"
              value={form.dia}
              onChange={handleChange}
              variant="filled"
              style={{ width: 72, flexShrink: 0 }}
            >
              {DAYS.map(d => (
                <MenuItem key={d} value={d}>
                  {d}
                </MenuItem>
              ))}
            </StyledTextField>
            <StyledTextField
              select
              name="mes"
              label="Mes"
              value={form.mes}
              onChange={handleChange}
              variant="filled"
              style={{ flex: 1 }}
            >
              {MONTHS.map(m => (
                <MenuItem key={m.value} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
            </StyledTextField>
            <StyledTextField
              select
              name="anio"
              label="Año"
              value={form.anio}
              onChange={handleChange}
              variant="filled"
              style={{ width: 90, flexShrink: 0 }}
            >
              {YEARS.map(y => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </StyledTextField>
          </div>
        </div>
        <CheckboxWrapper>
          <FormControlLabel
            control={
              <Checkbox
                checked={form.experienciaVales}
                onChange={handleCheckbox}
                name="experienciaVales"
                color="primary"
              />
            }
            label="Marca si ya tienes experiencia en vales (opcional)"
          />
        </CheckboxWrapper>
      </FormGrid>
      <PrimaryButton onClick={handleNext} disabled={!isValid || isLoading}>
        {isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          'Continuar'
        )}
      </PrimaryButton>
    </Card>
  );
}

StepDatos.propTypes = {
  onNext: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

StepDatos.defaultProps = {
  isLoading: false,
};
